module.exports = __webpack_public_path__ + "files/0b50e9fec92ea4ef7d5b5d9c132d6427.png";